import React, { SetStateAction, useCallback, useState } from 'react'
import { Card, CardBody, Col } from 'reactstrap';
import DataTable from 'react-data-table-component';
import { deleteDataTableColumns, deleteRowData, rowsSelectionSubTitle } from '../../../../Data/Tables/DataTables/API';
import { DeleteRowData } from '../../../../Types/Tables.type';
import CommonCardHeader from '../../../../Utils/CommonComponents/CommonCardHeader';
import { DeleteRow, RowsSelectionAndDeletionTitle } from '../../../../Utils/Constants';
import { Btn } from '../../../../AbstractElements';
import FilterComponent from '../Common/FilterComponent';
import { showDeleteConfirmModal } from '../../../../Components/ConfirmModal';

export default function RowSelectionAndDeletion() {
    const [filterText, setFilterText] = useState('');
    const [data, setData] = useState(deleteRowData);
    const [selectedRows, setSelectedRows] = useState<DeleteRowData[]>([]);
    const [toggleCleared, setToggleCleared] = useState(false);
    const handleRowSelected = useCallback((state: { selectedRows: SetStateAction<DeleteRowData[]> }) => {
        setSelectedRows(state.selectedRows);
    }, []);
    const handleDelete = () => {
        if (selectedRows.length === 0) return;

        showDeleteConfirmModal({
            title: "Bulk Delete Rows",
            content: `Are you sure you want to delete ${selectedRows.length} selected row(s): ${selectedRows.map((r: DeleteRowData) => r.name).join(', ')}? This action cannot be undone.`,
            onOk: () => {
                setToggleCleared(!toggleCleared);
                setData(data.filter((item) => (selectedRows.filter((elem: DeleteRowData) => elem.id === item.id).length > 0 ? false : true)));
                setSelectedRows([]);
            },
        });
    };
    const filteredItems: DeleteRowData[] = data.filter(
        (item: DeleteRowData) => {
            return Object.values(item).some((value) =>
                value && value.toString().toLowerCase().includes(filterText.toLowerCase())
            );
        }
    );
    return (
        <Col sm={12}>
            <Card>
                <CommonCardHeader headClass='pb-0 card-no-border' title={RowsSelectionAndDeletionTitle} subTitle={rowsSelectionSubTitle} />
                <CardBody>
                    <div className="table-responsive custom-scrollbar">
                        <Btn color='secondary' className="mb-3" onClick={handleDelete}>{DeleteRow}</Btn>
                        <FilterComponent
                            onFilter={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)}
                            filterText={filterText}
                        />
                        <DataTable className='custom-scrollbar' columns={deleteDataTableColumns} data={filteredItems} pagination selectableRows onSelectedRowsChange={handleRowSelected} clearSelectedRows={toggleCleared} striped />
                    </div>
                </CardBody>
            </Card>
        </Col>
    )
}
